import React from 'react';
import Type from 'prop-types';
import { Field } from 'formik';
import { RadioGroup, TextField } from 'formik-material-ui';
import { FormControlLabel, Radio } from '@material-ui/core';
import { DatePickerField } from 'components';
import { ru } from 'locale';
import options from './EditForm.mock';

const EditForm = props => {
  const { fieldName } = props;

  switch (fieldName) {
    case 'limit':
      return (
        <Field
          type="number"
          name="limit"
          label={ru.limit}
          component={TextField}
          inputProps={{
            inputMode: 'numeric',
            pattern: '[0-9]*',
          }}
          autoFocus
          autoComplete="off"
          fullWidth
          disabled={false}
        />
      );

    case 'term':
      return (
        <Field
          type="number"
          name="term"
          label={ru.term}
          component={TextField}
          autoFocus
          autoComplete="off"
          inputProps={{
            inputMode: 'numeric',
            pattern: '[0-9]*',
          }}
          fullWidth
          disabled={false}
        />
      );

    case 'comment':
      return (
        <Field
          name="comment"
          label={ru.comment}
          component={TextField}
          autoFocus
          autoComplete="off"
          rowsMax="4"
          multiline
          fullWidth
          disabled={false}
        />
      );

    case 'status':
      return (
        <Field name="status" component={RadioGroup}>
          {options.map(({ value, label }) => (
            <FormControlLabel key={value} label={label} value={value} control={<Radio />} />
          ))}
        </Field>
      );

    case 'dateTo':
      return (
        <Field
          name="dateTo"
          label={ru.dateTo}
          component={DatePickerField}
          variant="static"
          format="dd/MM/yyyy"
          disablePast
        />
      );

    default:
      return null;
  }
};

EditForm.propTypes = {
  fieldName: Type.string.isRequired,
};

export default EditForm;
